import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/site/Common";
import { post, errMsg } from "@/lib/api";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await post("/auth/forgot", { email }); setSent(true); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="rounded-3xl border border-slate-200 bg-white p-7 shadow-sm">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto size-10 text-emerald-600" />
            <h1 className="mt-3 font-heading text-2xl font-extrabold">Revisa tu correo</h1>
            <p className="mt-2 text-sm text-slate-600">Si {email} tiene cuenta, te hemos enviado un enlace para crear una nueva contraseña.</p>
            <Link to="/login" className="mt-5 inline-block text-sm font-semibold text-orange-600">Volver a entrar</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <h1 className="font-heading text-2xl font-extrabold">Recuperar contraseña</h1>
            <Field label="Email"><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" data-testid="forgot-email-input" /></Field>
            <Button type="submit" className="w-full rounded-xl" size="lg" disabled={busy} data-testid="forgot-submit-btn">{busy && <Loader2 className="animate-spin" />}Enviar enlace</Button>
          </form>
        )}
      </div>
    </div>
  );
}
